var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", [
    _c("div", { staticClass: "footer_wrap" }, [
      _c("p", [
        _c("span", { on: { click: _vm.devGuidePopup } }, [
          _vm._v("\n                © Samsung\n            ")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "link" }, [
          _c(
            "a",
            {
              attrs: { href: "javascript:" },
              on: { click: _vm.openPrivacyPopup }
            },
            [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.ETC.062")))]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "link_site" }, [
        _c("ul", [
          _c("li", [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectRhqCd,
                    expression: "selectRhqCd"
                  }
                ],
                staticClass: "slt_footer",
                attrs: { id: "selectRhqCd", name: "selectRhqCd" },
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.selectRhqCd = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    function($event) {
                      return _vm.changeRhqCd($event)
                    }
                  ]
                }
              },
              _vm._l(_vm.rhqCdList, function(item) {
                return _c(
                  "option",
                  { key: item.code, domProps: { value: item.code } },
                  [_vm._v(_vm._s(item.codeName))]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "select",
              {
                staticClass: "slt_footer",
                attrs: { id: "selectRhqSubCd", name: "selectRhqSubCd" },
                on: {
                  change: function($event) {
                    return _vm.changeRhqSubCd($event)
                  }
                }
              },
              _vm._l(_vm.rhqSubCdList, function(item, index) {
                return _c(
                  "option",
                  {
                    key: item.code,
                    domProps: {
                      value: item.code,
                      selected: _vm.selectRhqSubCd
                        ? item.code == _vm.selectRhqSubCd
                          ? true
                          : false
                        : index === 0
                        ? true
                        : false
                    }
                  },
                  [_vm._v(_vm._s(item.codeName))]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn_white",
                attrs: { href: "javascript:" },
                on: { click: _vm.reLogin }
              },
              [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.GO")))]
            )
          ]),
          _vm._v(" "),
          _vm._m(0)
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("picture", [
        _c("source", {
          attrs: {
            srcset: "/static/images/logo_footer-mo.png",
            media: "(max-width: 767px)"
          }
        }),
        _vm._v(" "),
        _c("source", {
          attrs: {
            srcset: "/static/images/logo_footer.png",
            media: "(max-width: 1023px)"
          }
        }),
        _vm._v(" "),
        _c("img", {
          attrs: { src: "/static/images/logo_footer.png", alt: "SAMSUNG SKP" }
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47c3d72e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47c3d72e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/main/SKPFooter.vue
// module id = CtJV
// module chunks = 0